import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

interface IOmnisearchAutocorrectProps extends FlexProps {
  autocorrected: boolean;
  autocorrectedQuery: string;
}

export const OmnisearchAutocorrect: FC<IOmnisearchAutocorrectProps> = ({
  autocorrected,
  autocorrectedQuery,
  ...rest
}) => {
  const { t } = useTranslation();
  const { query, forcedQuery, change } = useQueryParams<{ query: string; forcedQuery: string }>({
    query: StringParam,
    forcedQuery: StringParam,
  });

  function setForcedQuery() {
    change({ forcedQuery: query, query }, { method: 'replace', shallow: true });
  }

  const disabledAutocorrect = forcedQuery === query;

  if (!autocorrected || disabledAutocorrect) return null;
  return (
    <Flex justifyContent="center" mb="2" mt="2" {...rest}>
      <Text fontSize="sm" color="black">
        {`${t('lectureOmnisearch.autocorrectShowingResults')} `}
        <Text as="span" fontWeight="bold">
          {`${autocorrectedQuery}. `}
        </Text>
        {`${t('lectureOmnisearch.autocorrectDidYouMean')} `}
        <Text onClick={setForcedQuery} as="button" color="violet.500" fontWeight="bold">
          {query}
        </Text>
        ?
      </Text>
    </Flex>
  );
};
